import angular from 'angular';
import periodListLinkComponent from './periodListLink.component';

let periodListLinkModule = angular.module('periodListLink', [
])

.component('periodListLink', periodListLinkComponent)

.name;

export default periodListLinkModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacationsMobile/periodListLink/periodListLink.js